module.exports = __webpack_public_path__ + "static/media/icon_aws-redshift.f0714249.svg";